import { useCallback, useEffect, useState } from "react";
import { AiOutlineArrowLeft } from "react-icons/ai";
import { BiCurrentLocation } from "react-icons/bi";
import { useHistory } from "react-router";
import { toast } from "react-toastify";
import { ZipInput } from "../../../components/inputMasks";
import { useRegister } from "../../../context/RegisterContext";
import { api } from "../../../services/api";
import { NeighborhoodAlert } from "./NeighborhoodAlert";
import { NeighborhoodSanitization } from "./NeighborhoodSanitization";
import { useDebouncedCallback } from "use-debounce";
import { SpaceLoader } from "../../loaders/spaceLoader";
import { ButtonsContainer, Container, Dropdown, Header, InputContainer } from "./style";
import { InputLog, InputNumber, InputZipCode, Logo, NeighborhoodsList } from "./style";
import { Combobox } from "../../Forms/combobox";
import { MapModal } from "./MapModal";

export function RegisterAddressPersonPage() {
	const history = useHistory();
	const { handleUpdateAddress, missingToFillInput } = useRegister();
	const { handleSecondPageRegisterData, updateAddress } = useRegister();

	const [citiesList, setCitiesList] = useState([]);
	const [searchAddress, setSearchAddress] = useState("");
	const [searchingAddresses, setSearchingAddresses] = useState(false);
	const [addressesFound, setAddressesFound] = useState([]);
	const [nameBusiness] = useState(localStorage.getItem("@Inoveclube:nameBusiness"));
	const [cityIsEnabled, setCityIsEnabled] = useState(false);
	const [enableNeighborhoodsTable, setEnableNeighborhoodsTable] = useState(false);
	const [inputNeighborhoodIsFocused, setInputNeighborhoodIsFocused] = useState(false);
	const [neighborhoodsResults, setNeighborhoodsResults] = useState([]);
	const [hasZipCode, setHasZipCode] = useState(false);
	const [zipCodeIsLoading, setZipCodeIsLoading] = useState(false);
	const [firstSearchDone, setFirstSearchDone] = useState(false);
	const [startLL, setStartLL] = useState({ lat: null, lng: null });
	const [state, setState] = useState(
		updateAddress.initialState === true
			? updateAddress.address.state
			: localStorage.getItem("@Inoveclube:saveAllowedAddress")
				? JSON.parse(localStorage.getItem("@Inoveclube:saveAllowedAddress")).state
				: "",
	);
	const [idCity, setIdCity] = useState(
		updateAddress.initialState === true
			? updateAddress.address.idCity
			: localStorage.getItem("@Inoveclube:saveAllowedAddress")
				? JSON.parse(localStorage.getItem("@Inoveclube:saveAllowedAddress")).idCity
				: "",
	);
	const [neighborhood, setNeighborhood] = useState(
		updateAddress.initialState === true
			? updateAddress.address.neighborhood
			: localStorage.getItem("@Inoveclube:saveAllowedAddress")
				? JSON.parse(localStorage.getItem("@Inoveclube:saveAllowedAddress")).neighborhood
				: "",
	);
	const [street, setStreet] = useState(
		updateAddress.initialState === true
			? updateAddress.address.street
			: localStorage.getItem("@Inoveclube:saveAllowedAddress")
				? JSON.parse(localStorage.getItem("@Inoveclube:saveAllowedAddress")).street
				: "",
	);
	const [number, setNumber] = useState(
		updateAddress.initialState === true
			? updateAddress.address.number
			: localStorage.getItem("@Inoveclube:saveAllowedAddress")
				? JSON.parse(localStorage.getItem("@Inoveclube:saveAllowedAddress")).number
				: "",
	);
	const [zipCode, setZipCode] = useState(
		updateAddress.initialState === true
			? updateAddress.address.zipCode
			: localStorage.getItem("@Inoveclube:saveAllowedAddress")
				? JSON.parse(localStorage.getItem("@Inoveclube:saveAllowedAddress")).zipCode
				: "",
	);
	const [complement, setComplement] = useState(
		updateAddress.initialState === true
			? updateAddress.address.complement
			: localStorage.getItem("@Inoveclube:saveAllowedAddress")
				? JSON.parse(localStorage.getItem("@Inoveclube:saveAllowedAddress")).complement
				: "",
	);
	const [reference, setReference] = useState(
		updateAddress.initialState === true
			? updateAddress.address.reference
			: localStorage.getItem("@Inoveclube:saveAllowedAddress")
				? JSON.parse(localStorage.getItem("@Inoveclube:saveAllowedAddress")).reference
				: "",
	);
	const [warningNeighborhoods, setWarningNeighborhoods] = useState({
		list: [],
		open: false,
	});
	const [mapModal, setMapModal] = useState({
		isOpen: false,
		position: null,
		addressDescription: "",
		selectedAddressData: null,
	});
	const [coordinates, setCoordinates] = useState({
		latitude: null,
		longitude: null,
	});
	const [isConfirmingMap, setIsConfirmingMap] = useState(false);

	const handleInputFocus = useCallback(() => {
		setInputNeighborhoodIsFocused(true);
	}, []);

	const handleInputBlur = useCallback(() => {
		setInputNeighborhoodIsFocused(false);
	}, []);

	const handleMapModalClose = useCallback(() => {
		setMapModal({
			isOpen: false,
			position: null,
			addressDescription: "",
			selectedAddressData: null,
		});
	}, []);

	const handleMapConfirm = useCallback(
		async (selectedPosition) => {
			if (
				selectedPosition?.lat === mapModal.position?.lat &&
				selectedPosition?.lng === mapModal.position?.lng
			) {
				setHasZipCode(true);
				handleMapModalClose();
				return;
			}

			try {
				setIsConfirmingMap(true);
				// Get the info from the new rote
				const { data } = await api.get("/v1/getAddressDetailPin/", {
					params: { lat: selectedPosition.lat, lng: selectedPosition.lng },
				});

				// Apply address data to form
				setSearchAddress(mapModal.addressDescription || "");
				setZipCode(data.body.address.cep || "");
				setState(data.body.address.state || "");

				setIdCity(data.body.address.idCity || "");

				setNeighborhood(data.body.address.neighborhood || "");

				setStreet(data.body.address.address || "");

				setNumber(data.body.address.numero || "");
				setComplement(data.body.address.complement || "");

				// Store coordinates from map selection
				setCoordinates({
					latitude: selectedPosition.lat,
					longitude: selectedPosition.lng,
				});

				setHasZipCode(true);
				handleMapModalClose();

				toast.success("Localização confirmada com sucesso!");
			} catch (error) {
				console.error("Error confirming map location:", error);
				toast.error("Erro ao confirmar localização");
			} finally {
				setIsConfirmingMap(false);
			}
		},
		[mapModal.addressDescription, handleMapModalClose, mapModal.position],
	);

	function verifyingNeighborhoodIsAllowed() {
		if (!localStorage.getItem("@Inoveclube:neighborhoods")) return false;

		if (
			!JSON.parse(localStorage.getItem("@Inoveclube:neighborhoods")).some(
				(ngbhd) => ngbhd === neighborhood,
			)
		) {
			const list =
				neighborhoodsResults.length > 0
					? neighborhoodsResults
					: NeighborhoodSanitization(neighborhood);

			setWarningNeighborhoods({
				list,
				open: true,
			});
			return true;
		}
	}

	async function saveAddressData() {
		if (neighborhood === undefined || neighborhood.trim() === "") {
			toast.error("Preencha o bairro");
			return;
		}

		if (!state || !idCity) {
			toast.info("Preencha o estado e cidade");
			return;
		}

		const neighbordhood =
			JSON.parse(localStorage.getItem("@Inoveclube:neighborhoods")) || [];

		if (neighbordhood.length > 0) {
			if (verifyingNeighborhoodIsAllowed()) return;
		}

		const token = localStorage.getItem("@Inoveclube:token");

		const addressDataToSave = {
			state,
			idCity,
			neighborhood,
			street,
			number,
			zipCode: zipCode.replace(/\D/g, ""), // only numbers
			complement,
			reference,
			...(coordinates.latitude &&
				coordinates.longitude && {
					latitude: coordinates.latitude,
					longitude: coordinates.longitude,
				}),
		};

		if (updateAddress.initialState === true) {
			await handleSecondPageRegisterData({
				...addressDataToSave,
				idAddress: updateAddress.address.idAddress,
			});
		} else {
			await handleSecondPageRegisterData({
				...addressDataToSave,
				token: token,
			});
		}
	}

	const handleSearchAddress = useDebouncedCallback(async ({ input }) => {
		if (!input) setHasZipCode(false);
		setSearchingAddresses(true);
		const result = localStorage.getItem("@Inoveclube:nameBusiness");
		const { data } = await api.get("/v1/searchAddresses/", {
			params: { address: input, nameBusiness: result },
		});
		const { data: details } = await api.get("/v1/getAddressDetail/", {
			params: { place_id: data.body.addresses[0]?.place_id },
		});
		setAddressesFound(data.body.addresses || []);
		setSearchingAddresses(false);
		setFirstSearchDone(true);

		setStartLL({
			lat: details.body?.address?.latitude,
			lng: details.body?.address?.longitude,
		});
	}, 1000);

	async function handleGetAddressDetails(option) {
		setHasZipCode(false);
		setZipCodeIsLoading(true);

		try {
			const { data } = await api.get("/v1/getAddressDetail/", {
				params: { place_id: option.place_id },
			});

			const addressData = {
				zipCode: data.body.address.cep || "",
				state: data.body.address.state ? data.body.address.state.toUpperCase() : "",
				city: data.body.address.city || "",
				neighborhood: data.body.address.neighborhood || "",
				street: data.body.address.address || "",
				number: data.body.address.numbenumeror || "",
				complement: data.body.address.complement || "",
				latitude: data.body.address.latitude,
				longitude: data.body.address.longitude,
			};

			setZipCode(data.body.address.cep || "");
			setState(data.body.address.state || "");

			setIdCity(data.body.address.idCity || "");

			setNeighborhood(data.body.address.neighborhood || "");

			setStreet(data.body.address.address || "");

			setIdCity(data.body.address.idCity || "");

			setNeighborhood(data.body.address.neighborhood || "");

			setStreet(data.body.address.address || "");

			setNumber(data.body.address.numero || "");
			setComplement(data.body.address.complement || "");

			// Store address data to apply after map confirmation
			setMapModal({
				isOpen: true,
				position:
					addressData.latitude && addressData.longitude
						? {
								lat: Number.parseFloat(addressData.latitude),
								lng: Number.parseFloat(addressData.longitude),
							}
						: null,
				addressDescription: option.description,
				selectedAddressData: addressData,
			});

			setZipCodeIsLoading(false);
		} catch (error) {
			console.error("Error getting address details:", error);
			toast.error("Erro ao buscar detalhes do endereço");
			setZipCodeIsLoading(false);
		}
	}

	useEffect(() => {
		if (warningNeighborhoods.open) handleInputBlur();
	}, [warningNeighborhoods, handleInputBlur]);

	useEffect(() => {
		if (state !== "" && citiesList.length > 0) setCityIsEnabled(true);
	}, [state, citiesList]);

	useEffect(() => {
		if (state !== "") {
			api.get(`/getCities/${state}`).then((response) => setCitiesList(response.data));
		}
	}, [state]);

	useEffect(() => {
		if (
			neighborhood !== "" &&
			localStorage.getItem("@Inoveclube:nameBusiness") &&
			inputNeighborhoodIsFocused === true
		) {
			setEnableNeighborhoodsTable(true);
		} else {
			setEnableNeighborhoodsTable(false);
		}
	}, [neighborhood, inputNeighborhoodIsFocused]);

	useEffect(() => {
		if (localStorage.getItem("@Inoveclube:neighborhoods")) {
			const results = JSON.parse(
				localStorage.getItem("@Inoveclube:neighborhoods"),
			).filter((product) => product.toLowerCase().includes(neighborhood.toLowerCase()));
			setNeighborhoodsResults(results);
		}
	}, [neighborhood]);

	useEffect(() => {
		if (localStorage.getItem("@Inoveclube:nameBusiness")) {
			setState(localStorage.getItem("@Inoveclube:state"));
			setIdCity(localStorage.getItem("@Inoveclube:idCity"));
		}
	}, []);

	useEffect(() => {
		if (nameBusiness === "BurguerGrill") {
			setZipCode("0000-000");
			setHasZipCode("29101-000");
		}
	}, [nameBusiness]);

	return (
		<Container>
			<Header>
				<AiOutlineArrowLeft
					style={{
						opacity: isConfirmingMap ? 0.5 : 1,
						pointerEvents: isConfirmingMap ? "none" : "auto",
					}}
					onClick={() => {
						if (isConfirmingMap) return;
						if (JSON.parse(localStorage.getItem("@Inoveclube:active?")) === true) {
							handleUpdateAddress({ initialState: false, address: {} });
							localStorage.setItem(
								"@Inoveclube:updateAddress",
								JSON.stringify({ initialState: false, address: {} }),
							);
							history.push("/address");
						} else if (localStorage.getItem("@Inoveclube:shopping")) {
							history.push("/shopping");
						} else {
							history.push("/login");
						}
					}}
				/>
				<h1>Adicionar endereço</h1>
			</Header>

			<InputContainer>
				<Logo />

				<Combobox
					className="combobox"
					value={searchAddress}
					name="address"
					label="Buscar endereço"
					disabled={isConfirmingMap}
					onChange={({ e, option }) => {
						if (option?.place_id === "none") {
							setMapModal({
								isOpen: true,
								position: startLL,
								addressDescription: "",
								selectedAddressData: null,
							});
							return;
						}
						if (isConfirmingMap) return;
						if (option) {
							handleGetAddressDetails(option);
						} else {
							let addressToSearch = e.target.value;
							if (Number(addressToSearch)) {
								if (addressToSearch.length > 5) {
									addressToSearch = `${addressToSearch.slice(
										0,
										5,
									)}-${addressToSearch.slice(5, 8)}`;
								}
							}
							setSearchAddress(e.target.value);
							handleSearchAddress({ input: addressToSearch });
						}
					}}
					loading={searchingAddresses || isConfirmingMap}
					placeholder={
						isConfirmingMap ? "Confirmando localização..." : "Buscar endereço..."
					}
					description="description"
					option
					options={
						firstSearchDone
							? [
									...addressesFound,
									{ place_id: "none", description: "📍 Buscar pelo mapa" },
								]
							: addressesFound
					}
				/>

				{zipCodeIsLoading && <SpaceLoader />}
				{isConfirmingMap && (
					<div style={{ textAlign: "center", padding: "10px" }}>
						<SpaceLoader />
						<p style={{ marginTop: "10px", color: "#666" }}>Confirmando localização...</p>
					</div>
				)}

				{hasZipCode && (
					<>
						<InputZipCode alertUserToFillInput={zipCode === "" && missingToFillInput}>
							<ZipInput
								name="zipInput"
								type="text"
								placeholder="CEP"
								value={zipCode}
								onChange={(event) => setZipCode(event.target.value)}
							/>
						</InputZipCode>

						<div className="container-divide">
							<Dropdown
								className="smaller"
								alertUserToFillInput={state === "" && missingToFillInput}
							>
								<select onChange={(event) => setState(event.target.value)} value={state}>
									<option value="" hidden>
										UF
									</option>
									<option value="AC">AC</option>
									<option value="AL">AL</option>
									<option value="AM">AM</option>
									<option value="AP">AP</option>
									<option value="BA">BA</option>
									<option value="CE">CE</option>
									<option value="DF">DF</option>
									<option value="ES">ES</option>
									<option value="GO">GO</option>
									<option value="MA">MA</option>
									<option value="MG">MG</option>
									<option value="MS">MS</option>
									<option value="MT">MT</option>
									<option value="PA">PA</option>
									<option value="PB">PB</option>
									<option value="PE">PE</option>
									<option value="PI">PI</option>
									<option value="PR">PR</option>
									<option value="RJ">RJ</option>
									<option value="RN">RN</option>
									<option value="RO">RO</option>
									<option value="RR">RR</option>
									<option value="RS">RS</option>
									<option value="SC">SC</option>
									<option value="SE">SE</option>
									<option value="SP">SP</option>
									<option value="TO">TO</option>
								</select>
							</Dropdown>

							<Dropdown
								cityIsEnabled={cityIsEnabled}
								alertUserToFillInput={idCity === "" && missingToFillInput}
							>
								<select
									onChange={(event) => setIdCity(event.target.value)}
									value={idCity}
								>
									<option value="" disabled selected hidden>
										CIDADE
									</option>
									{citiesList.map((city) => (
										<option key={city.idCity} value={city.idCity}>
											{city.city}
										</option>
									))}
								</select>
							</Dropdown>
						</div>

						<div className="container-divide">
							<InputNumber
								className="smaller"
								type="text"
								placeholder="N°"
								value={number}
								maxLength={15}
								alertUserToFillInput={number === "" && missingToFillInput}
								onChange={(event) => setNumber(event.target.value)}
							/>

							<InputLog alertUserToFillInput={street === "" && missingToFillInput}>
								<input
									type="text"
									placeholder="ENDEREÇO. Ex: Rua, Avenida"
									value={street.toUpperCase()}
									maxLength={100}
									onChange={(event) => setStreet(event.target.value)}
								/>
							</InputLog>
						</div>

						<InputLog
							className="neighborhood"
							alertUserToFillInput={neighborhood === "" && missingToFillInput}
						>
							<input
								type="text"
								placeholder="BAIRRO"
								value={neighborhood.toUpperCase()}
								maxLength={300}
								onFocus={handleInputFocus}
								onChange={(event) => setNeighborhood(event.target.value)}
							/>
							{enableNeighborhoodsTable ? (
								<NeighborhoodsList>
									<div className="line" />
									<div className="neighborhoods">
										{neighborhoodsResults.length > 0 ? (
											neighborhoodsResults.map((neighborhood, index) => (
												<div
													key={index}
													onClick={() => {
														setNeighborhood(neighborhood);
														handleInputBlur();
													}}
													onKeyPress={() => {
														setNeighborhood(neighborhood);
														handleInputBlur();
													}}
												>
													<BiCurrentLocation />
													<p>{neighborhood}</p>
												</div>
											))
										) : (
											<p className="notFound">nenhum resultado correspondente</p>
										)}
									</div>
									<div
										className="closeNeighborhoods"
										onClick={() => handleInputBlur()}
										onKeyPress={() => handleInputBlur()}
									>
										Fechar sugestões
									</div>
								</NeighborhoodsList>
							) : (
								<></>
							)}
						</InputLog>

						<InputLog>
							<input
								type="text"
								placeholder="COMPLEMENTO"
								value={complement.toUpperCase()}
								maxLength={300}
								onChange={(event) => setComplement(event.target.value)}
							/>
						</InputLog>

						<InputLog>
							<input
								type="text"
								placeholder="REFERÊNCIA"
								value={reference.toUpperCase()}
								maxLength={300}
								onChange={(event) => setReference(event.target.value)}
							/>
						</InputLog>

						<ButtonsContainer>
							<button
								className="logButton g-recaptcha"
								data-sitekey="6LcmFyAcAAAAANYtWCTkXQDnnGB7aVoSAisllMfC"
								data-callback="handleSubmit"
								data-size="invisible"
								SameSite="secure"
								type="button"
								disabled={isConfirmingMap}
								onClick={() => saveAddressData()}
								onKeyPress={() => saveAddressData()}
							>
								{isConfirmingMap ? "CONFIRMANDO LOCALIZAÇÃO..." : "SALVAR"}
							</button>
						</ButtonsContainer>
					</>
				)}
			</InputContainer>

			<NeighborhoodAlert
				warningNeighborhoods={warningNeighborhoods}
				setWarningNeighborhoods={setWarningNeighborhoods}
				setNeighborhood={setNeighborhood}
			/>

			<MapModal
				isOpen={mapModal.isOpen}
				onClose={handleMapModalClose}
				onConfirm={handleMapConfirm}
				initialPosition={mapModal.position}
				addressDescription={mapModal.addressDescription}
				isLoading={isConfirmingMap}
			/>
		</Container>
	);
}
